(function () {
  document.documentElement.classList.add('r33-js');
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var px = [];
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }) : null;
  function onScroll() {
    if (reduce || !px.length) return;
    var vh = innerHeight;
    px.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = (vh - r.top) / (vh + r.height); p = p < 0 ? 0 : p > 1 ? 1 : p;
      var sp = parseFloat(el.getAttribute('data-speed')) || 60;
      el.style.transform = 'translateY(' + (sp * (1 - 2 * p)).toFixed(1) + 'px)';
    });
  }
  function scan(root) {
    (root || document).querySelectorAll('.r33-reveal:not([data-seen])').forEach(function (el) {
      el.setAttribute('data-seen', '1'); if (io) io.observe(el); else el.classList.add('is-in');
    });
    if (!reduce) (root || document).querySelectorAll('.r33-parallax:not([data-seen])').forEach(function (el) {
      el.setAttribute('data-seen', '1'); px.push(el);
    });
    onScroll();
  }
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function () { scan(); });
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', function () { scan(); });
})();
